<template>
  <div class="panel" :style="{ background: contantBackground }">
    <Title :title="data.themeName" />
    <div class="body clearfix" :class="[data.sort ? 'line-2' : 'line-3']">
      <template v-for="item in data.themeGoodsList">
        <Item :key="item.goodsNo" :data="item" :coupons="data.coupons" />
      </template>
    </div>
  </div>
</template>

<script>
import Title from "../../Title";
import Item from "./item";
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },

    contantBackground: {
      type: String,
      default: "red",
    },
  },

  // components: { Title, Item, CardTitle },
  components: { Title, Item },
};
</script>

<style lang="less" scoped>
.panel {
  padding: 0 20px;
}
.body {
  text-align: left;
  padding: 0 14px;
  .item {
    float: left;
  }
  &.line-2 {
    .item {
      width: 334px;
      margin-right: 13px;
      margin-bottom: 13px;
      &:nth-of-type(2n) {
        margin-right: 0;
      }
    }
  }
  &.line-3 {
    .item {
      width: 32.2%;
      margin-right: 1.7%;
      margin-bottom: 1.7%;
      &:nth-of-type(3n) {
        margin-right: 0;
      }
    }
  }
}
</style>
